import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { faBattleNet } from '@fortawesome/free-brands-svg-icons';

import login from '../util/login';

export default class LoginButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: false
        };
    }

    componentDidMount() {
        login.addEventListener(this.handleLoginEvent);
    }

    componentWillUnmount() {
        login.removeEventListener(this.handleLoginEvent);
    }

    handleLoginEvent = () => {
        // if login status changes, we need to re-render
        this.setState({ loginEvent: Date.now() });
    }

    characters = () => {
        const token = JSON.parse(localStorage.getItem('token.blizzard'));
        if (!token.region || !token.expires_at) {
            // invalid token
            return this.logout();
        } else if (token.expires_at < Date.now()) {
            // expired token
            this.props.history.push('/redirect?to=blizzard&from=' + encodeURIComponent('/mycharacters') + '&region=' + encodeURIComponent(token.region));
        } else {
            // already logged in
            this.props.history.push('/mycharacters');
        }
    }

    logout = () => {
        localStorage.removeItem('token.patreon');
        localStorage.removeItem('token.twitch');
        localStorage.removeItem('token.blizzard');
        login.jwt.set(null);

        this.props.history.push('/');
    }

    toggleLogin = (event) => {
        this.setState({ login: this.state.login ? false : event.currentTarget });
    }

    closeLogin = () => {
        this.setState({ login: false });
    }

    render() {
        const loggedin = localStorage.getItem('token.blizzard');
        if (loggedin) {
            return (
                <div className="btn-group">
                    <Tooltip title="View your characters using Battle.net login">
                        <button type="button" className="btn btn-primary" onClick={this.characters}>
                            <FontAwesomeIcon icon={faUsers} />
                        </button>
                    </Tooltip>
                    <Tooltip title="Logout">
                        <button type="button" className="btn btn-primary" onClick={this.logout}>
                            <FontAwesomeIcon icon={faSignOutAlt} />
                        </button>
                    </Tooltip>
                </div>
            );
        } else {
            return (
                <div>
                    <Tooltip title={this.state.login ? null : 'View your characters using Battle.net login'}>
                        <button type="button" className="btn btn-primary" onClick={this.toggleLogin}><FontAwesomeIcon icon={faBattleNet} />{window.bootstrap.lg.matches ? ' Login' : null}</button>
                    </Tooltip>
                    <Popper open={Boolean(this.state.login)} anchorEl={this.state.login} placement="bottom-end">
                        <ClickAwayListener onClickAway={this.closeLogin}>
                            <div className="btn-group-vertical mt-1">
                                {[ 'eu', 'kr', 'tw', 'us' ].map(region => <Link key={region} to={'/redirect?to=blizzard&from=' + encodeURIComponent('/mycharacters') + '&region=' + encodeURIComponent(region)} className="btn btn-primary px-5 w-100 text-center">{region.toUpperCase()}</Link>)}
                            </div>
                        </ClickAwayListener>
                    </Popper>
                </div>
            );
        }
    }
}